import { render, staticRenderFns } from "./TreasureTable.vue?vue&type=template&id=6f78a4c8&scoped=true"
import script from "./TreasureTable.vue?vue&type=script&lang=js"
export * from "./TreasureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78a4c8",
  null
  
)

export default component.exports